/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-14T10:40:36.048
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listFinancialEvidence,
	listFinancialEvidenceInit,
	listFinancialEvidenceByAuthorizations,
	deleteFinancialEvidence
	
} from '@api/financial/FinancialEvidence';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listFinancialEvidence({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialEvidence(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialEvidenceByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialEvidenceByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialEvidenceInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialEvidenceInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteFinancialEvidence({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteFinancialEvidence({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
